/** Meta information about another node, stored as a child of the node */
import * as z from 'zod'
import { baseEntitySchema } from '../../core/entity.js'

const settingsSchema = z.object({
  /** Transpose the song display, e.g., for trumpets */
  transpose: z.number().optional(),
  /**
   * Perform: this person's parts for this song only, overriding their band's parts. Stored as plain
   * strings (read through `normalizeParts`) so an unknown part cannot invalidate the row.
   */
  parts: z.array(z.string()).describe('Per-song override of the performer parts.').optional(),
  /** Perform: show chord shapes or concert pitch for this song (capo > 0 with Guitar). Absent means shapes. */
  frame: z.enum(['shapes', 'concert']).describe('Shapes or concert pitch for this song.').optional(),
})

/** Personalized user settings */
export const userSettingsSchema = baseEntitySchema.extend({
  type: z.literal('usersettings'),
  parentId: z.string(),
  settings: settingsSchema,
})

export type UserSettings = z.infer<typeof userSettingsSchema>
export type UserSettingsData = z.infer<typeof settingsSchema>
